<template>
  <div>
    <div>
      <p class="bold">חלון מספר 3 מתוך 3</p>
    </div>
    <div>
      <p style="font-size: 30px;"><b>{{payload.company.name}} (ID: {{payload.company.id}})</b></p>
      <div>
        <p><b>Location *</b></p>
        <vue-google-autocomplete
        style="width: 510px;"
        class="outlined full_width"
        id="searchbox"
        :country="['il', 'ps']"
        types="geocode"
        placeholder="הקלד/י מיקום..."
        @change="updateAddress"
        @placechanged="updateLatLong">
        </vue-google-autocomplete>
      </div>
      <div>
        <p><b>Public Hidden Name *</b></p>
        <input v-model="public_hidden_name" class="outlined full_width">
      </div>
      <div>
        <p><b>Internal Notes (לא חובה)</b></p>
        <textarea v-model="internal_notes" placeholder="..." class="full_width"></textarea>
      </div>
      <div>
        <p><b>About The Company (לא חובה)</b></p>
        <textarea v-model="about_the_company" placeholder="..." class="full_width"></textarea>
      </div>
    </div>
    <div class="vertical_space"></div>
    <div class="vertical_space"></div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >סיום</a
      >
    </div>
  </div>
</template>
<script>
import TextsHelper from '@/custom/classes/texts_helper.js'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import { mapMutations } from 'vuex'
export default {
  name: 'create-company-step-three',
  props: ['payload'],
  data () {
    return {
      texts_helper: new TextsHelper(),
      is_loading: false,
      public_hidden_name: '',
      internal_notes: '',
      about_the_company: '',
      latitude: 0,
      longitude: 0,
      location_description: '',
      company_id: this.payload.company.id
    }
  },
  methods: {
    submit () {
      // Check if company_id exists before proceeding
      if (!this.company_id) {
        this.$utils.emit('show_toast', { text: 'שגיאה: מזהה החברה חסר. לא ניתן להמשיך.' })
        return
      }

      let internal_notes_content = this.texts_helper.getBoldContent(this.internal_notes, 'internal_notes')
      if (this.public_hidden_name.length == 0) {
        this.$utils.emit('show_toast', { text: 'Public Hidden Name ריק' })
        return
      }
      if (this.location_description.length == 0) {
        this.$utils.emit('show_toast', { text: 'Location ריק' })
        return
      }
      if (internal_notes_content == 'problem') {
        return
      }
      this.is_loading = true
      let requests = []
      requests.push(...this.getTextsPostRequests())
      requests.push(...this.getStatPostRequests())
      requests.push(this.getLocationRequest())
      this.$caller.axios.all(requests).then(() => {
        this.create({
          designator: 'create-company-step-four',
          component_name: 'CreateCompanyStepFour',
          ignore_escape_button: true,
          company: this.payload.company,
          modal_title: 'Create new Company'
        })
        this.payload.is_fixed = false
        this.remove(this.payload)
        this.$utils.emit('show_toast', { text: 'success' })
      })
    },
    getLocationRequest () {
      return this.$network_utils.postLocation({ current_type: 'Company', current_resource_id: this.company_id, lat: this.latitude, long: this.longitude, description: this.location_description })
    },
    getStatPostRequests () {
      return [this.$network_utils.postStat({ title: 'new internal note', designator: 'internal_notes', content: this.internal_notes, resource_type: 'Company', resource_id: this.company_id, owner: this.owner, priority: this.$utils.getInternalNotesMinPriority('Company') })]
    },
    getTextsPostRequests () {
      let requests = []
      requests.push(this.$network_utils.postText({ designator: 'public_hidden_name', content: this.public_hidden_name, current_type: 'Company', current_resource_id: this.company_id }))
      if (this.about_the_company.length > 0) {
        requests.push(this.$network_utils.postText({ designator: 'about_the_company', content: this.about_the_company, current_type: 'Company', current_resource_id: this.company_id }))
      }
      return requests
    },
    updateLatLong (address_data) {
      this.latitude = address_data.latitude
      this.longitude = address_data.longitude
    },
    updateAddress (address) {
      this.location_description = address
    },
    ...mapMutations('modals', ['remove', 'create'])
  },
  components: {
    VueGoogleAutocomplete
  }
}
</script>
<style>
  .pac-container{
    z-index: 100000000;
  }
</style>
